import { render, staticRenderFns } from "./ExcelDownloader.vue?vue&type=template&id=4490e44a"
import script from "./ExcelDownloader.vue?vue&type=script&lang=js"
export * from "./ExcelDownloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports